import React from 'react';
import { ROLE_COLORS, ROLE_LABELS } from './calculations/reutRoles.js';

const SIZE = 200;
const CENTER = SIZE / 2;
const RADIUS = 74;
const STROKE = 26;
const GAP = 3; // écart visuel entre tranches, en unités du cercle (surface gap)
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

/**
 * Donut de répartition de la consommation par catégorie, colorié par rôle REUT (gisement /
 * débouché / hors périmètre) plutôt que par catégorie individuelle — cf. categoryBreakdown.js.
 * Légende en dessous, avec valeur et part, pour servir aussi de "vue table" (accessibilité).
 */
const CategoryDonut = ({ categories }) => {
  const total = categories.reduce((sum, c) => sum + c.volume, 0);

  let cumulative = 0;
  const segments = categories.map(cat => {
    const fraction = total > 0 ? cat.volume / total : 0;
    const rawLength = fraction * CIRCUMFERENCE;
    const length = Math.max(0, rawLength - GAP);
    const offset = -cumulative;
    cumulative += rawLength;
    return { ...cat, length, offset };
  });

  return (
    <div className="gw-donut">
      <svg viewBox={`0 0 ${SIZE} ${SIZE}`} width={SIZE} height={SIZE} role="img" aria-label="Répartition de la consommation par catégorie">
        <circle cx={CENTER} cy={CENTER} r={RADIUS} fill="none" stroke="#eeeeea" strokeWidth={STROKE} />
        {segments.map((seg, i) => (
          <circle
            key={i}
            cx={CENTER} cy={CENTER} r={RADIUS}
            fill="none"
            stroke={ROLE_COLORS[seg.role]}
            strokeWidth={STROKE}
            strokeDasharray={`${seg.length} ${CIRCUMFERENCE - seg.length}`}
            strokeDashoffset={seg.offset}
            transform={`rotate(-90 ${CENTER} ${CENTER})`}
          />
        ))}
        <text x={CENTER} y={CENTER - 6} textAnchor="middle" className="gw-donut-total">
          {total.toLocaleString('fr-FR', { maximumFractionDigits: 0 })}
        </text>
        <text x={CENTER} y={CENTER + 14} textAnchor="middle" className="gw-donut-unit">m³/an</text>
      </svg>

      <div className="gw-donut-legend">
        {categories.map(cat => (
          <div className="gw-donut-legend-row" key={cat.name}>
            <span className="gw-donut-swatch" style={{ background: ROLE_COLORS[cat.role] }} />
            <span className="gw-donut-legend-name">{cat.name}</span>
            <span className="gw-donut-legend-role">{ROLE_LABELS[cat.role]}</span>
            <span className="gw-donut-legend-value">
              {cat.volume.toLocaleString('fr-FR', { maximumFractionDigits: 0 })} m³
              {' '}({total > 0 ? Math.round((cat.volume / total) * 100) : 0}%)
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CategoryDonut;
